/* Exporting login mutations. */
export default {
    /**
     * * Set the loggedIn property to true and set the token property to the token passed in
     * @param state - The state object that is being updated.
     * @param token - The token that was returned by the login API.
     */
    LOGIN_SUCCESS(state, data) {
      state.loggedIn = true;
      state.token = data.token;
      state.user = data.user;
    },
    LOGIN_AAD_SUCCESS(state, data) {
      state.loggedIn = true;
      state.authData = data;
    },

    LOGIN_FAILURE(state) {
      state.loggedIn = false;
      state.token = null;
      state.user = null;
    },

    LOGIN_AAD_FAILURE(state) {
      state.loggedIn = false;
      state.authData = null;
    },
    /* Setting the loggedIn property to false and setting the token property to null. */
    LOGOUT(state) {
      state.loggedIn = false;
      state.token = null;
      state.user = null;
      state.authData = null;
    },

    LOGOUT_AAD(state) {
      state.loggedIn = false;
      state.authData = null;
    },
    /* This is a mutation that is used to update the token property of the state object. */
    REFRESH_TOKEN(state, access_token) {
      state.status.loggedIn = true;
      state.token = { ...state.token, access_token: access_token };
    },
    USER_SUCCESS(state, data) {
      state.userData = data;
    },

    USER_FAILURE(state) {
      state.userData = null;
    },
  };
  